import { render, staticRenderFns } from "./PersonalReport2.vue?vue&type=template&id=0b77d939&scoped=true&"
import script from "./PersonalReport2.vue?vue&type=script&lang=js&"
export * from "./PersonalReport2.vue?vue&type=script&lang=js&"
import style0 from "./PersonalReport2.vue?vue&type=style&index=0&id=0b77d939&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b77d939",
  null
  
)

export default component.exports